import { render } from "./HeroiconsSolidVolumeUp.vue?vue&type=template&id=757b576c"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidVolumeUp.vue"]])

export default __exports__